import { render } from "./Liquidation.vue?vue&type=template&id=e3de46a6&scoped=true&ts=true"
import script from "./Liquidation.vue?vue&type=script&lang=ts"
export * from "./Liquidation.vue?vue&type=script&lang=ts"

import "./Liquidation.vue?vue&type=style&index=0&id=e3de46a6&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3de46a6"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSkeleton});
